import oval1 from 'assets/img/mex/oval-login1.svg';
import oval2 from 'assets/img/mex/oval-login2.svg';
import LoginMex from 'components/LoginMex/LoginMex';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { limpiarLogin, loginFetchMex } from 'redux/actions/aLogin';
import { encriptarContrasenia } from 'utils/Encriptar';
import { addCookieManager } from 'utils/aigCookies';
import Loading from 'wrappers/Loading';

class ContainerLoginMex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usrModificado: {},
    };
    this.props.limpiarDatos();
  }

  componentDidMount() {
    addCookieManager();
  }

  verificarUsuarioLogeado() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const goBackTo = queryParams.get('goBackTo');

    if (this.props.dataUsuario && this.props.dataUsuario.userIsLoggedIn) {
      if (goBackTo) {
        return this.props.history.replace(goBackTo);
      }

      if (this.props.dataUsuario.usu_tipo_usuario !== 'cliente') {
        return this.props.history.push('/?ShowNovedades=true');
      } else {
        return this.props.history.push('/listado-pre-polizas');
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Uso tipico (no olvides de comparar los props):
    if (prevProps.dataUsuario !== this.props.dataUsuario) {
      this.verificarUsuarioLogeado();
    }
  }
  /**
   *
   * @param {{
   *  correo:string,
   *  contrasenia:string
   * }} param
   */
  handleIniciarSesion = async (param) => {
    const dataLogin = {
      cliUsuario: param?.correo,
      cliPassword: encriptarContrasenia(param.contrasenia),
      carHash: '',
    };
    console.log(dataLogin);
    await this.props.loginUsuario(dataLogin);
  };

  funcionPush() {
    const queryParams = new URLSearchParams(this.props.location.search);
    let from = queryParams.get('from');
    let accion = queryParams.get('accion');
    if (from !== undefined && from === 'pago') {
      const queryParams = new URLSearchParams(this.props.location.search);
      let id = queryParams.get('id');
      let estado = queryParams.get('estado');
      this.props.history.replace({
        pathname: `/final-cotizacion`,
        search: `?id=${id}&estado=${estado}`,
      });
    } else if (accion !== undefined && accion === 'nuevo') {
      this.props.history.replace('/cotizacion?accion=nuevo');
    } else if (this.props.location.state && this.props.location.state.prevLocation) {
      this.props.history.replace(this.props.location.state.prevLocation);
    } else {
      this.props.history.replace('/principal');
    }
  }

  render() {
    const loadingProps = {
      loading: this.props.loginIsLoading,
      message: 'Verificando datos',
    };

    return (
      <Loading {...loadingProps}>
        <Row>
          <Col lg={3} md={3} sm={12} xs={12} className="hidden-xs hidden-sm">
            <img src={oval1} className="img-backgroundHome-circle6" alt="img" />
            <img src={oval2} className="img-backgroundHome-circle7" alt="img" />
            <div className="left-backgroud-login" />
          </Col>
          <Col lg={9} md={9} sm={12} xs={12}>
            <div className="wraper-login-mex">
              <LoginMex loginError={this.props.loginHasError} />
              <div className="copyright-text">
                <p></p>
              </div>
            </div>
          </Col>
        </Row>
      </Loading>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginIsLoading, loginHasError, dataUsuario } = state.datosUsuarios;

  return {
    //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
    datosUsuario: state.datosUsuarios,
    loginIsLoading,
    loginHasError,
    dataUsuario,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUsuario: (dataLogin) => dispatch(loginFetchMex(dataLogin)),
    limpiarDatos: () => dispatch(limpiarLogin()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerLoginMex));
